import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
/**
 * Created by h3 on 2018-09-06.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FruitsGameConfig} from "../../FruitsGameConfig";
import {FruitsSoundConfig} from "../../FruitsSoundConfig";
import {FruitsGameMode} from "../../gamemode/FruitsGameMode";
import {FruitsReelSymbol} from "../../reelsymbol/FruitsReelSymbol";
import {FruitsParsedGameData} from "../../server/data/FruitsParsedGameData";

export class FruitsWildReelStopPresentation extends ReelStopPresentationController {
    private _mode:string;
    private _parsedSymbolOverlayPositions:boolean[][];
    private _overlayStickySymbolsBeforeSpin:boolean[];

    constructor(index:number) {
        super(index, "FruitsWildReelStopPresentation");
    }

    protected parseFeatureGameData(data:FruitsParsedGameData):void {
        this._mode = data.mode;
        this._parsedSymbolOverlayPositions = FruitsWildReelStopPresentation.parseSymbolOverlayPositions(data.symbolOverlayPositions);
        this._overlayStickySymbolsBeforeSpin = data.overlayStickySymbolsBeforeSpin;
    }

    private static parseSymbolOverlayPositions(symbolOverlayPositions:boolean[][]):boolean[][] {
        let parsedSymbolOverlayPositions = [];
        for(let i = 0; i < symbolOverlayPositions.length; i++) {
            for(let j = 0; j < symbolOverlayPositions[i].length; j++) {
                if(i === 0 && j === 0 || i === 1 && j === 0) {
                    continue;
                }
                parsedSymbolOverlayPositions.push([symbolOverlayPositions[i][j]]);
            }
        }
        return parsedSymbolOverlayPositions;
    }

    public onReelBounce(data:IReelStoppedData):void {
        this.handleExceptions();

        const symbol:FruitsReelSymbol = <FruitsReelSymbol>Reels.getSymbol(data.reelId, 0)!;

        if(symbol.symName === "W") {
            symbol.changeState({
                state : FruitsGameConfig.instance.SYMBOL_STATES.land,
                fadeInDuration : 0,
                replay : false
            });
            this.playWildAttentionSound(data.reelId)

        }
        this.dispatchCompleteEvent(data.reelId);
    }

    private playWildAttentionSound(reelId:number) {

        if(this._parsedSymbolOverlayPositions[reelId][0] || this._overlayStickySymbolsBeforeSpin[reelId]) {
            return;
        } else {
            SlotGame.sound.playEffect(FruitsSoundConfig.WILD_ATTENTION);
        }

    }

    public playReelBouncingSound(data:IReelStoppedData):boolean {

        return false;
    }

    public playReelStopSound(data:IReelStoppedData):boolean {
        return false;
    }

    private handleExceptions():void {
        if(this._mode === FruitsGameMode.STICKY_RESPIN) {
            for(let i:number = 0; i < 4; i++) {
                this.dispatchCompleteEvent(i);
            }
        }
    }


}